<template>
  <section>
    <qx-card title="总览">
      <el-row>
        <el-col :span="4">
          结算月份：{{subsidyData.settleMonth}}
        </el-col>
        <el-col :span="4">
          司机姓名：{{subsidyData.carDriverName}}
        </el-col>
        <el-col :span="4">
          司机手机：{{subsidyData.carDriverPhone}}
        </el-col>
        <el-col :span="4">
          已发天数：<span class="primary">{{subsidyData.paidDays}}</span>
        </el-col>
        <el-col :span="4">
          未发天数：<span class="primary">{{subsidyData.noPayDays}}</span>
        </el-col>
      </el-row>
    </qx-card>
    <qx-card title="日历">
      <el-row class="dayBoxPa">
        <el-col
          v-for="day in dayNum"
          :key="day"
          :span="4"
          class="dayBox"
        >
          <p class="day">{{day + 1}}</p>
          <p :class="{
            warning: !subsidyData['fieldExt' + (day + 1)],
            primary: subsidyData['fieldExt' + (day + 1)],
          }">
            {{subsidyData['fieldExt' + (day + 1)] || '未发'}}
          </p>
        </el-col>
      </el-row>
    </qx-card>
  </section>
</template>

<script>
import {
  driverSalarySubsidy,
} from 'api/getPay';
export default {
  data () {
    return {
      subsidyData: {
      },
      dayNum: 0,
    };
  },
  async created () {
    this.subsidyData = await driverSalarySubsidy({
      salaryId: this.$route.query.id,
    });
    const ym = this.subsidyData.settleMonth.split('-');
    this.dayNum = new Date(ym[0], ym[1], 0).getDate();
  },
};
</script>

<style scoped lang="scss">
.infoItem{
  margin-right: 16px;
}
.dayBoxPa{
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  .dayBox{
    border-bottom: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    padding: 16px 0;
    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    box-sizing: border-box;
    .day{
      margin-bottom: 8px;
    }
  }
}
</style>
